import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import BaseSpread from './spreads/base-spread';
import HoroscopeTarotSpread from './spreads/horoscope-tarot';
import MandalaSpread from './spreads/mandala';
import YesOrNoSpread from './spreads/yes-or-no';

class Component extends BaseComponent {
    render({ row_breakpoints, view }) {
        const [Spread, type] = this.getSpreadDisplayInfo();

        return (
            <tarot-spread>
                <Spread
                    row_breakpoints={row_breakpoints}
                    view={view}
                    type={type}
                />
            </tarot-spread>
        );
    }

    getSpreadDisplayInfo = () => {
        if (this.props.upc.match(/mandala/)) {
            const match = this.props.upc.match(/mandala-(\w*-?\w*)-tarot-redux/);
            return [MandalaSpread, match && match[1]];
        } else if (this.props.upc == 'horoscope-tarot-redux') {
            return [HoroscopeTarotSpread];
        } else if (this.props.upc == 'yes-or-no-tarot-redux') {
            return [YesOrNoSpread];
        }

        return [BaseSpread, this.props.spread_type];
    }
}

const mapStateToProps = (state) => ({
    row_breakpoints: state.product && state.product.row_breakpoints,
    spread_type: state.product && state.product.spread_type,
    upc: state.product && state.product.teeup && state.product.teeup.code,
});

export default connect(mapStateToProps)(Component);
